import React from "react";
import { EditPage } from "../../../blocks/blog-edit/EditPage";

export const BlogPublishPage = () => {
  return <EditPage />;
};
